<form class="register-form" (submit)="onSubmit($event)" [formGroup]="registerForm">
  <h1 class="title">{{ "auth.title.register" | translate }}</h1>

  <div class="steps" [ngClass]="getStepClassname()">

    <section id="register_identification">

      <div class="register__input-wrapper">
        <mat-form-field appearance="fill" class="input">
          <mat-label>{{ "auth.fields.username" | translate }}</mat-label>
          <input matInput autocomplete="username" type="text" formControlName="username"
            (keypress)="isUsernameCharacter($event)" (paste)="$event.preventDefault()"
            (keydown.enter)="$event.preventDefault()" maxlength="32" />
        </mat-form-field>
        <mat-icon [ngClass]="getFormControlIconClassname('username')" color="primary" aria-label="check"
          svgIcon="check"></mat-icon>
      </div>
      <div class="register__input-wrapper">
        <mat-form-field appearance="fill" class="input">
          <mat-label>{{ "auth.fields.email" | translate }}</mat-label>
          <input matInput autocomplete="email" type="email" formControlName="email"
            (keydown.enter)="$event.preventDefault()" />
        </mat-form-field>
        <mat-icon [ngClass]="getFormControlIconClassname('email')" color="primary" aria-label="check"
          svgIcon="check"></mat-icon>
      </div>
      <div class="form-field__wrapper">

        <div class="register__input-wrapper">
          <mat-form-field appearance="fill" class="input">
            <mat-label>{{ "auth.fields.password" | translate }}</mat-label>
            <input matInput autocomplete="new-password" type="password" formControlName="password"
              (keydown.enter)="$event.preventDefault()" />
          </mat-form-field>
          <mat-icon class="register__input__check-icon-hidden" color="primary" aria-label="check"></mat-icon>
        </div>

        <div class="register__input-wrapper">
          <mat-form-field appearance="fill" class="input">
            <mat-label>{{ "auth.fields.confirm_password" | translate }}</mat-label>
            <input matInput autocomplete="new-password" type="password" formControlName="confirm_password"
              (keydown.enter)="$event.preventDefault()" />
          </mat-form-field>
          <mat-icon [ngClass]="getFormControlIconClassnamePassword()" color="primary" aria-label="check"
            svgIcon="check"></mat-icon>
        </div>
      </div>

    </section>

    <section id="register_personnal">
      <div class="register__input-wrapper">
        <mat-radio-group aria-label="Select an option" formControlName="gender" style="width: 100%;">
          <mat-radio-button value="male">{{"auth.fields.gender.male" | translate}}</mat-radio-button>
          <mat-radio-button value="female">{{"auth.fields.gender.female" | translate}}</mat-radio-button>
          <mat-radio-button value="other">{{"auth.fields.gender.other" | translate}}</mat-radio-button>
        </mat-radio-group>
        <mat-icon [ngClass]="getFormControlIconClassname('gender')" color="primary" aria-label="check"
          svgIcon="check"></mat-icon>
      </div>

      <div class="form-field__wrapper">
        <div class="register__input-wrapper">
          <mat-form-field appearance="fill" class="input">
            <mat-label>{{ "auth.fields.firstName" | translate }}</mat-label>
            <input matInput formControlName="firstName" (keydown.enter)="$event.preventDefault()" />
          </mat-form-field>
          <mat-icon class="register__input__check-icon-hidden" color="primary" aria-label="check"></mat-icon>
        </div>
        <div class="register__input-wrapper">
          <mat-form-field appearance="fill" class="input">
            <mat-label>{{ "auth.fields.lastName" | translate }}</mat-label>
            <input matInput formControlName="lastName" (keydown.enter)="$event.preventDefault()" />
          </mat-form-field>
          <mat-icon [ngClass]="getFormControlIconClassname(['firstName', 'lastName'])" color="primary"
            aria-label="check" svgIcon="check"></mat-icon>
        </div>
      </div>
      <div class="register__input-wrapper">
        <mat-form-field appearance="fill" class="input">
          <mat-label>{{ "auth.fields.address" | translate }}</mat-label>
          <input matInput formControlName="address" (keydown.enter)="$event.preventDefault()" />
        </mat-form-field>
        <mat-icon [ngClass]="getFormControlIconClassname('address')" color="primary" aria-label="check"
          svgIcon="check"></mat-icon>
      </div>
      <div class="form-field__wrapper">
        <div class="register__input-wrapper">
          <mat-form-field appearance="fill" class="input">
            <mat-label>{{ "auth.fields.postal_code" | translate }}</mat-label>
            <input matInput formControlName="postalCode" (keydown.enter)="$event.preventDefault()" />
          </mat-form-field>
          <mat-icon class="register__input__check-icon-hidden" color="primary" aria-label="check"></mat-icon>
        </div>

        <div class="register__input-wrapper">
          <mat-form-field appearance="fill" class="input">
            <mat-label>{{ "auth.fields.city" | translate }}</mat-label>
            <input matInput formControlName="city" (keydown.enter)="$event.preventDefault()" />
          </mat-form-field>
          <mat-icon [ngClass]="getFormControlIconClassname(['postalCode', 'city'])" color="primary" aria-label="check"
            svgIcon="check"></mat-icon>
        </div>
      </div>
      <div class="register__input-wrapper">
        <mat-select-country style="width: 100%;" [label]="'auth.fields.country' | translate"
          formControlName="countrySelect" [value]="defaultValue" (onCountrySelected)="onCountrySelected($event)">
        </mat-select-country>
        <mat-icon [ngClass]="getFormControlIconClassname('countrySelect')" color="primary" aria-label="check"
          svgIcon="check"></mat-icon>
      </div>
      <div class="form-field__wrapper">
        <div class="register__input-wrapper">
          <mat-form-field appearance="fill" class="input">
            <mat-label>{{ "auth.fields.landline_phone_number" | translate }}</mat-label>
            <input matInput formControlName="landlinePhoneNumber" (keydown.enter)="$event.preventDefault()" />
          </mat-form-field>
          <mat-icon class="register__input__check-icon-hidden" color="primary" aria-label="check"></mat-icon>
        </div>
        <div class="register__input-wrapper">
          <mat-form-field appearance="fill" class="input">
            <mat-label>{{ "auth.fields.mobile_phone_number" | translate }}</mat-label>
            <input matInput formControlName="mobilePhoneNumber" (keydown.enter)="$event.preventDefault()" />
          </mat-form-field>
          <mat-icon [ngClass]="getFormControlIconClassname(['landlinePhoneNumber','mobilePhoneNumber'])" color="primary"
            aria-label="check" svgIcon="check"></mat-icon>
        </div>
      </div>
      <div class="register__input-wrapper">
        <mat-form-field appearance="fill" class="input">
          <mat-label>{{ "auth.fields.secf_account" | translate }}</mat-label>
          <input matInput formControlName="secfAccount" (keydown.enter)="$event.preventDefault()" maxlength="7" />
        </mat-form-field>
        <mat-icon [ngClass]="getFormControlIconClassname(['secfAccount'])" color="primary" aria-label="check"
          svgIcon="check"></mat-icon>
      </div>
    </section>
    <section id="register_actions">
      récapitulatif de vos informations :
      <div>
        <label>{{ "auth.fields.username" | translate }} :</label><span>{{this.registerForm.value?.username}}</span>
      </div>
      <div>
        <label>{{ "auth.fields.email" | translate }} :</label><span>{{this.registerForm.value?.email}}</span>
      </div>
      <div>
        <label>Etat civil :</label>
        <span>{{this.registerForm.value?.gender == 'male' ? 'M.' :
          'Mme'}}&nbsp;{{this.registerForm.value?.firstName}}&nbsp;{{this.registerForm.value?.lastName}}</span>
      </div>
      <div>
        <label>{{ "auth.fields.address" | translate }} :</label>
        <span>{{this.registerForm.value?.address}}</span>&nbsp;
        <span>{{this.registerForm.value?.postalCode}}</span>&nbsp;
        <span>{{this.registerForm.value?.city}}</span>&nbsp;
        <span>{{this.registerForm.value?.country?.name}}</span>
      </div>
      <div>
        <label>Téléphone :</label>
        <span>{{this.registerForm.value?.landlinePhoneNumber}}</span>&nbsp;
        <span>{{this.registerForm.value?.mobilePhoneNumber}}</span>
      </div>
      <div>
        <label>{{ "auth.fields.secf_account" | translate }} :</label>
        <span>{{this.registerForm.value?.secfAccount}}</span>
      </div>

      <label class="actions__reminder">
        Si vos informations sont corrects, vous pouvez cliquez sur le bouton inscription.
      </label>
    </section>
    <section id="register-success">
      <span>Vous recevrez un mail, vérifiez aussi dans SPAM, avec le sujet <strong>"Les petites annonces du Trot : Merci
          de confirmer votre inscription"</strong>.
        Quand vous le recevrez, veuillez cliquer sur le bouton "Valider mon adresse email" afin de finaliser votre
        inscription</span>
    </section>
    <section id="register-error">erreur lors de la préinscription, veuillez rééssayer ou contacter l'administration du
      trot.com</section>
    <section id="register-conflictError">Nom d'utilisateur ou email déjà utilisé !  veuillez en choisir d'autres.</section>
  </div>
  <div class="actions">
    <button type="button" class="actions__prev" *ngIf="this.formState?.showPrev" mat-flat-button (click)="prevStep()">
      <div class="button__container">
        <mat-icon aria-hidden="previous" aria-label="prev" svgIcon="chevron-left"></mat-icon>
        <span>{{"crud.actions.prev" | translate }}</span>
      </div>
    </button>
    <button type="button" class="actions__next" *ngIf="this.formState?.showNext" mat-flat-button color="primary"
      (click)="nextStep()" [disabled]="!isCurrentStepValid()">
      <div class="button__container">
        <span>{{"crud.actions.next" | translate }}</span>
        <mat-icon aria-hidden="next" aria-label="next" svgIcon="chevron-right"></mat-icon>
      </div>
    </button>
    <button type="submit" *ngIf="this.formState?.finished" [disabled]="!registerForm.valid" mat-raised-button
      color="primary" class="actions__submit">
      <div class="button__container">
        {{ "auth.fields.submit.register" | translate }}
        <mat-icon aria-hidden="previous" aria-label="prev" svgIcon="check"></mat-icon>
      </div>
    </button>
  </div>
</form>
